import React from "react";

export const CKYCUploadFileWithName = (props) => {
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const ckycData = Array.isArray(props.CKYCData) ? props.CKYCData : [];
  const uploadId = props.title === "Identity" ? "POI" : "POA";
  const uploadCard = {
    background: "#fff",
    borderRadius: "18px",
  };

  return (
    <div className="ckyc-doc-block" style={uploadCard}>
      <div
        className="ckyc-doc-block__title"
        style={{ fontSize: "17px", marginBottom: "14px" }}
      >
        Proof of {props.title}{" "}
        <span>({props.title === "Identity" ? "POI" : "POA"})</span>
      </div>

      <div className="row g-3">
        <div className="col-12">
          <label className="ckyc-field-label">Document Type</label>
          <select
            className="packageForm ckyc-field"
            style={{
              minHeight: "52px",
              borderRadius: "14px",
              background: "#fdfefe",
            }}
            value={props.DocumentTypeID}
            onChange={(e) => props.setDocumentType(e.target.value)}
            required
          >
            <option value="">Select Document</option>
            {ckycData.map((row) => (
              <option value={row.Name} key={row.Name}>
                {row.Name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12">
          <label className="ckyc-field-label">Document Number</label>
          <input
            type="text"
            placeholder="Enter document ID"
            value={props.DocumentIDValue}
            onChange={(e) => props.setDocumentID(e.target.value)}
            className="packageForm ckyc-field"
            style={{
              minHeight: "52px",
              borderRadius: "14px",
              background: "#fdfefe",
            }}
            required
          />
        </div>

        <div className="col-12">
          <div
            className="UploadDocuments"
            style={{ display: props.DocumentBase64 === "" ? "" : "none" }}
          >
            <input
              type="file"
              accept="image/*"
              className="indemtexted"
              onChange={async (e) =>
                props.setDocumentBase64(await toBase64(e.target.files[0]))
              }
              name="fileUpload"
              id={uploadId}
              hidden
              required
            />
            <label
              htmlFor={uploadId}
              className="POS_File_Upload_Box ckyc-upload-dropzone"
              style={{
                minHeight: "120px",
                borderRadius: "18px",
                border: "1.5px dashed rgba(14, 97, 117, 0.28)",
                background:
                  "linear-gradient(180deg, rgba(245, 250, 251, 1) 0%, rgba(235, 246, 248, 1) 100%)",
              }}
            >
              <div className="ckyc-upload-dropzone__icon" style={{ width: "56px", height: "56px" }}>
                <img src={require("../Images/upload.svg")} alt="Upload" />
              </div>
              <div>
                <p>Click to upload file</p>
                <small>PNG, JPG or JPEG with clear readable details</small>
              </div>
            </label>
          </div>

          <div
            className="UIM_After02 ckyc-preview-card"
            style={{
              display: props.DocumentBase64 === "" ? "none" : "block",
              borderRadius: "18px",
              padding: "14px",
              border: "1px solid rgba(14, 97, 117, 0.12)",
              boxShadow: "0 16px 28px rgba(15, 42, 52, 0.08)",
            }}
          >
            <button
              type="button"
              className="close"
              onClick={() => props.setDocumentBase64("")}
            >
              X
            </button>
            <img
              src={props.DocumentBase64}
              title={props.title}
              alt={`${props.title} preview`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
